import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

export default function PublicFooter() {
  return (
    <footer className="bg-[#0A1128] border-t border-white/5" data-testid="public-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          {/* Brand */}
          <div className="lg:col-span-5">
            <img
              src="https://customer-assets.emergentagent.com/job_licensing-hub-3/artifacts/0s2i33uj_MM_Forsight%20Logo%20Png.png"
              alt="ForesightRx"
              className="h-10 w-auto brightness-0 invert mb-6"
            />
            <p className="text-[#687399] text-sm leading-relaxed max-w-sm mb-8">
              Partnering Intelligence & Deal Enablement for the global biotech ecosystem.
              We connect pharma BD teams with high-fit biotech assets and help biotech companies
              reach the partners that matter.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://www.linkedin.com/company/marksman-healthcare-communications/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-[#687399] hover:text-[#70C24C] hover:border-[#70C24C]/40 transition-all duration-300"
                data-testid="footer-linkedin"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
              </a>
              <a
                href="mailto:enquiry@foresightrx.com"
                className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-[#687399] hover:text-[#70C24C] hover:border-[#70C24C]/40 transition-all duration-300"
                data-testid="footer-email"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>
              </a>
            </div>
          </div>

          {/* Links */}
          <div className="lg:col-span-2">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-[#687399] mb-6">Platform</h4>
            <ul className="space-y-3">
              {[
                { to: '/platform', label: 'How It Works' },
                { to: '/services', label: 'Services & Pricing' },
                { to: '/partnering', label: 'Deal Pathway' },
                { to: '/apply', label: 'Get Started' },
              ].map(link => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-[#A1A8C3] hover:text-[#70C24C] transition-colors duration-300 flex items-center gap-1 group">
                    {link.label}
                    <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-[#687399] mb-6">Company</h4>
            <ul className="space-y-3">
              {[
                { to: '/about', label: 'About Us' },
                { href: 'mailto:enquiry@foresightrx.com', label: 'Contact' },
              ].map((link, i) => (
                <li key={i}>
                  {link.to ? (
                    <Link to={link.to} className="text-sm text-[#A1A8C3] hover:text-[#70C24C] transition-colors duration-300">{link.label}</Link>
                  ) : (
                    <a href={link.href} className="text-sm text-[#A1A8C3] hover:text-[#70C24C] transition-colors duration-300">{link.label}</a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-[#687399] mb-6">Get in Touch</h4>
            <a href="mailto:enquiry@foresightrx.com" className="text-sm text-[#A1A8C3] hover:text-[#70C24C] transition-colors duration-300 block mb-3">
              enquiry@foresightrx.com
            </a>
            <p className="text-xs text-[#687399] leading-relaxed">
              A MarksMan Healthcare Division
            </p>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#687399]">&copy; {new Date().getFullYear()} ForesightRx — A MarksMan Healthcare Division. All rights reserved.</p>
          <p className="text-xs text-[#687399]">Partnering Intelligence & Deal Enablement</p>
        </div>
      </div>
    </footer>
  );
}
